export default __webpack_public_path__ + "static/media/Group451.c92c7e5e.png";